import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "~/components/ui/sheet.jsx";
import { Button } from "~/components/ui/button.jsx";
import { MenuIcon } from "lucide-react";
import { Link, usePage } from "@inertiajs/react";
import { contacts_path, services_path, taxon_path } from "@/routes.js";
import { Dialog } from "@headlessui/react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import information from "../data/information";

export default function () {
  const { taxons } = usePage().props;

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost">
          <MenuIcon size={30} className="size-8" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="w-[90vw] text-base overflow-y-scroll scrollbar scrollbar-track-gray-50 scrollbar-thumb-gray-200"
      >
        <div className="p-8 pt-12 space-y-8">
          <Accordion
            type="multiple"
            collapsible
            defaultValue={["catalog", "services", "info"]}
          >
            <AccordionItem value="catalog">
              <AccordionTrigger>Каталог</AccordionTrigger>
              <AccordionContent>
                <ul className="mt-6 space-y-4 ">
                  {taxons.map((taxon, index) => (
                    <li key={`mobile-menu-category-${index}`}>
                      <MenuLink
                        href={taxon_path(taxon.permalink)}
                        className="text-gray-700 transition hover:opacity-75"
                      >
                        {taxon.pretty_name}
                      </MenuLink>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="services">
              <AccordionTrigger>Услуги</AccordionTrigger>
              <AccordionContent>
                <ul className="mt-6 space-y-4 ">
                  <li>
                    <MenuLink
                      className="text-gray-700 transition hover:opacity-75"
                      href={services_path({ anchor: "fontani" })}
                    >
                      Фотозоны
                    </MenuLink>
                  </li>

                  <li>
                    <MenuLink
                      className="text-gray-700 transition hover:opacity-75"
                      href={services_path({ anchor: "fontani" })}
                    >
                      Изготовлеине декораций
                    </MenuLink>
                  </li>

                  <li>
                    <Link
                      className="text-gray-700 transition hover:opacity-75"
                      href={services_path({ anchor: "banners" })}
                    >
                      Печать баннеров и плакатов
                    </Link>
                  </li>

                  <li>
                    <MenuLink
                      className="text-gray-700 transition hover:opacity-75"
                      href={services_path({ anchor: "biznes" })}
                    >
                      Оформление вашего бизнеса
                    </MenuLink>
                  </li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="info">
              <AccordionTrigger>Информация</AccordionTrigger>
              <AccordionContent>
                <ul className="mt-6 space-y-4 ">
                  {information.map((item, i) => (
                    <li key={`information-item-${i}`}>
                      <MenuLink
                        className="text-gray-700 transition hover:opacity-75"
                        href={item.link}
                      >
                        {item.name}
                      </MenuLink>
                    </li>
                  ))}
                  
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="border-t border-gray-100 p-8">
          <ul className="grid flex-wrap gap-4 text-xs">
            <li>
              <MenuLink
                href="#"
                className="text-gray-500 transition hover:opacity-75"
              >
                {" "}
                Terms & Conditions{" "}
              </MenuLink>
            </li>

            <li>
              <MenuLink
                href="#"
                className="text-gray-500 transition hover:opacity-75"
              >
                {" "}
                Privacy Policy{" "}
              </MenuLink>
            </li>

            <li>
              <MenuLink
                href="#"
                className="text-gray-500 transition hover:opacity-75"
              >
                {" "}
                Cookies{" "}
              </MenuLink>
            </li>
          </ul>
        </div>
      </SheetContent>
    </Sheet>
  );
}

const MenuLink = ({ children, ...props }) => {
  return (
    <Link href={props.href}>
      <SheetClose {...props}>{children}</SheetClose>
    </Link>
  );
};
